export default {"src":"/_next/static/media/parent-logo.9e44991a.svg","height":49,"width":204,"blurWidth":0,"blurHeight":0};